
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.5 3.5c.242 0 .438.196.438.438v2.624h2.625a.438.438 0 010 .875H7.937v2.625a.438.438 0 01-.875 0V7.438H4.438a.438.438 0 010-.875h2.625V3.938c0-.242.196-.438.438-.438z","fill":"#000"}})])
          )
        }
      }
    